import { createServerFn } from "@tanstack/react-start";

export type PublicTestimonialDTO = {
  id: string;
  customerName: string;
  designation: string;
  company: string;
  testimonial: string;
  rating: number;
  avatarUrl: string | null;
  altText: string | null;
  isDemo: boolean;
  sortOrder: number;
};

export const listActiveTestimonials = createServerFn({ method: "GET" }).handler(
  async (): Promise<PublicTestimonialDTO[] | null> => {
    try {
      // Import protection ensures this stays on server
      const { buildServerPublicClient } = await import("./testimonials.server");
      const supabase = buildServerPublicClient();
      const { data, error } = await supabase
        .from("testimonials")
        .select(
          "id, customer_name, designation, company, testimonial, rating, avatar_url, alt_text, is_demo, sort_order",
        )
        .eq("is_active", true)
        .order("sort_order", { ascending: true });
      if (error) {
        console.error("[testimonials] read failed", error);
        return null;
      }
      return (data ?? []).map((r) => ({
        id: r.id,
        customerName: r.customer_name,
        designation: r.designation,
        company: r.company,
        testimonial: r.testimonial,
        rating: r.rating,
        avatarUrl: r.avatar_url,
        altText: r.alt_text,
        isDemo: r.is_demo,
        sortOrder: r.sort_order,
      }));
    } catch (err) {
      console.error("[testimonials] unexpected error", err);
      return null;
    }
  },
);